import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Sirve si soy principiante?',
  a: 'Sí, está hecho desde cero. No necesitás conocimientos previos ni experiencia en ventas.'
}, {
  q: '¿Necesito dinero?',
  a: 'No, podés empezar sin inversión inicial utilizando las estrategias orgánicas que enseñamos.'
}, {
  q: '¿Cuándo lo recibo?',
  a: 'Acceso inmediato. Una vez realizado el pago, recibís todo el material en tu correo al instante.'
}, {
  q: '¿Funciona en Argentina?',
  a: 'Sí, está 100% pensado y adaptado para el mercado argentino actual.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-dark-900" data-id="element-31">
      <div className="text-center mb-16" data-id="element-32">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-33">
          ❓ PREGUNTAS FRECUENTES
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-34">
        {faqs.map((faq, idx) => <div key={idx} className="bg-dark-800 border border-dark-700 rounded-xl overflow-hidden" data-id="element-35">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-36">
              <span className="text-lg font-bold text-white" data-id="element-37">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-38" />
            </button>
            <AnimatePresence data-id="element-39">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-40">
                  <div className="p-6 pt-0 text-gray-400 border-t border-dark-700/50 mt-2" data-id="element-41">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}